import React, { useEffect } from "react";
import ServiceTemplate from "../components/ServiceTemplate";

import webBanner from "../images/web-1.png";
import webBig from "../images/web-2.png";
import webCollage from "../images/web-3.png";

import {
  FaGlobe,
  FaMobileAlt,
  FaPalette,
  FaPlug,
  FaServer
} from "react-icons/fa";

export default function WebApp() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sidebar = [
    { title: "Custom Web Apps", icon: FaGlobe },
    { title: "Mobile Apps (iOS/Android)", icon: FaMobileAlt },
    { title: "UI / UX Design", icon: FaPalette },
    { title: "API & Integrations", icon: FaPlug },
    { title: "Maintenance & Hosting", icon: FaServer },
  ];

  const features = [
    "Custom front-end & back-end builds",
    "Responsive UI/UX design",
    "Mobile-first engineering",
    "Payment & third-party API integrations",
    "DevOps & hosting support",
  ];

  return (
    <ServiceTemplate
      title="Website & Mobile App Design"
      bannerImage={webBanner}
      bigImage={webBig}
      collageImage={webCollage}
      sidebarItems={sidebar}
      features={features}
    />
  );
}
